import { MY_ACTIVITY_PAGE } from 'constants/pages';
import { pluralize } from 'utils/shared/pluralize';
import InfoAlert from 'components/InfoAlert';
import Link from 'components/Link';

interface Props {
  /** Requests the viewer may still send; `null` renders nothing. */
  remaining: number | null;
  className?: string;
}

/** The pending-request quota, shown in the request form and on the success step. */
export default function RemainingRequestsAlert({ remaining, className }: Props) {
  if (remaining === null) return null;

  if (remaining === 0) {
    return (
      <InfoAlert
        variant="error"
        iconType="info"
        title="You've used all your requests."
        desc="Wait for a host to respond to one of your pending requests before sending another."
        className={className}
      >
        <Link
          href={MY_ACTIVITY_PAGE}
          className="typography-product-button-label-small text-color-error underline"
        >
          See your requests
        </Link>
      </InfoAlert>
    );
  }

  return (
    <InfoAlert
      variant="brand"
      iconType="info"
      title={`You have ${pluralize({ count: remaining, singular: 'request' })} remaining.`}
      className={className}
    />
  );
}
